import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./queryClient.js";
import { Toast } from "@swivu/shared-ui";
import { Outlet } from "react-router-dom";
import { SettingsContextProvider } from "../hooks/useSettings.js";

const Providers = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsContextProvider>
        <Toast.Toaster />
        <Outlet />
      </SettingsContextProvider>
    </QueryClientProvider>
  );
};

export default Providers;
